import StepForm from '../../stepForm/StepForm';
import stepsConfig from '../../stepsConfig';

/** Step 2 — Package details */
function PackagesStep(props) {
    return (
        <StepForm
            stepConfig={stepsConfig.packages}
            formData={props.formData?.packages || {}}
            onChange={props.onChange}
            errors={props.errors}
            setErrors={props.setErrors}
            cityOptions={props.cityOptions}
            isCitiesLoading={props.isCitiesLoading}
            tripCountry={props.tripCountry}
            tripCountries={props.tripCountries}
            tripCurrency={props.tripCurrency}
            tripId={props.tripId}
            tripsList={props.tripsList}
            isTripsLoading={props.isTripsLoading}
            packageId={props.formData?.packages?.package_id}
            packageInitialImageUrl={props.packageHeroImage}
            pendingPackageImagePreviewUrl={props.pendingPackageImagePreviewUrl}
            onPendingPackageImageSelect={props.handlePendingPackageImageSelect}
            onPendingPackageImageClear={props.handlePendingPackageImageClear}
        />
    );
}

export default PackagesStep;
